import React, { useState } from "react";

interface PaymentMethodProps {
    paymentMethod: string;
    setPaymentMethod: (method: string) => void;
}

export default function PaymentMethod({ paymentMethod, setPaymentMethod }: PaymentMethodProps) {
    // Lifted state to parent
    // const [paymentMethod, setPaymentMethod] = useState("PAYMENT_METHOD_BANK");

    return (
        <div id="delivery__info_payment" style={{ width: "100%" }}>
            <div className="MuiPaper-root styles_root__PnlWX MuiPaper-elevation0 MuiPaper-rounded">

                {/* ----- TITLE ----- */}
                <div className="styles_boxTitle__EihvK">
                    <h1 className="styles_title__WsbwW">Phương thức thanh toán</h1>
                    <span className="styles_decs___uINl">
                        (Vui lòng lựa chọn 1 trong 2 hình thức thanh toán)
                    </span>
                </div>

                <fieldset className="MuiFormControl-root">

                    <div className="styles_paymentMethodsGrid__ay1iS">

                        {/* ================= OPTION 1: THANH TOÁN KHI NHẬN HÀNG ================= */}
                        <div className="MuiFormGroup-root styles_fieldset__BqASy" role="radiogroup">
                            <label
                                className={
                                    "MuiFormControlLabel-root " +
                                    (paymentMethod === "PAYMENT_METHOD_COD" ? "active_payment" : "")
                                }
                            >
                                <span
                                    className={
                                        "MuiButtonBase-root MuiIconButton-root jss1 MuiRadio-root MuiRadio-colorSecondary jss2 !p-0 " +
                                        (paymentMethod === "PAYMENT_METHOD_COD"
                                            ? "styles_checkbox_color__KTpvK"
                                            : "")
                                    }
                                >
                                    <span className="MuiIconButton-label">
                                        <input
                                            className="jss4"
                                            type="radio"
                                            value="PAYMENT_METHOD_COD"
                                            name="payment-radio"
                                            checked={paymentMethod === "PAYMENT_METHOD_COD"}
                                            onChange={() => setPaymentMethod("PAYMENT_METHOD_COD")}
                                        />

                                        <div
                                            className={
                                                "jss5 " +
                                                (paymentMethod === "PAYMENT_METHOD_COD" ? "jss7" : "")
                                            }
                                        >
                                            {/* outer circle */}
                                            <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall" viewBox="0 0 24 24">
                                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"></path>
                                            </svg>

                                            {/* inner filled */}
                                            <svg className="MuiSvgIcon-root jss6 MuiSvgIcon-fontSizeSmall" viewBox="0 0 24 24">
                                                <path d="M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"></path>
                                            </svg>
                                        </div>
                                    </span>
                                </span>

                                <span className="MuiTypography-root MuiFormControlLabel-label MuiTypography-body1">
                                    <div className="MuiBox-root css-1c1kq07">
                                        <div className="MuiBox-root css-1enwbvd">
                                            <h6 className="styles_fw500__Ev_4_">
                                                Thanh toán tiền mặt khi nhận hàng
                                            </h6>
                                        </div>
                                        <div className="MuiBox-root css-5geqnf"></div>
                                    </div>
                                </span>
                            </label>
                        </div>

                        {/* ================= OPTION 2: CHUYỂN KHOẢN ================= */}
                        <div className="MuiFormGroup-root styles_fieldset__BqASy" role="radiogroup">
                            <label
                                className={
                                    "MuiFormControlLabel-root " +
                                    (paymentMethod === "PAYMENT_METHOD_BANK" ? "active_payment" : "")
                                }
                            >
                                <span
                                    className={
                                        "MuiButtonBase-root MuiIconButton-root jss1 MuiRadio-root MuiRadio-colorSecondary jss2 !p-0 " +
                                        (paymentMethod === "PAYMENT_METHOD_BANK"
                                            ? "styles_checkbox_color__KTpvK"
                                            : "")
                                    }
                                >
                                    <span className="MuiIconButton-label">
                                        <input
                                            className="jss4"
                                            type="radio"
                                            value="PAYMENT_METHOD_BANK"
                                            name="payment-radio"
                                            checked={paymentMethod === "PAYMENT_METHOD_BANK"}
                                            onChange={() => setPaymentMethod("PAYMENT_METHOD_BANK")}
                                        />

                                        <div
                                            className={
                                                "jss5 " +
                                                (paymentMethod === "PAYMENT_METHOD_BANK" ? "jss7" : "")
                                            }
                                        >
                                            {/* outer */}
                                            <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall" viewBox="0 0 24 24">
                                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"></path>
                                            </svg>

                                            {/* inner */}
                                            <svg className="MuiSvgIcon-root jss6 MuiSvgIcon-fontSizeSmall" viewBox="0 0 24 24">
                                                <path d="M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"></path>
                                            </svg>
                                        </div>
                                    </span>
                                </span>

                                <span className="MuiTypography-root MuiFormControlLabel-label MuiTypography-body1">
                                    <div className="MuiBox-root css-1c1kq07">

                                        <div className="MuiBox-root css-1enwbvd">
                                            <h6 className="styles_fw500__Ev_4_">
                                                Chuyển khoản (Giảm 0.5%)
                                            </h6>

                                            <div className="styles_subTitle__J5Agn">
                                                Hoàn tiền chênh lệch tự động 24/7 trước khi giao hàng (nếu có)
                                            </div>
                                        </div>

                                        <div className="MuiBox-root css-5geqnf">
                                            <span style={{ position: "relative", display: "inline-block" }}>
                                                <img
                                                    alt="Chuyển khoản (Giảm 0.5%)"
                                                    src="https://gcs.buymed.com/thuocsi-live/internal/cms/2025703db716adf07888c42d8dc76b05name=OCB,_style=square.svg"
                                                    style={{
                                                        margin: "auto",
                                                        width: "18px",
                                                        height: "18px",
                                                        maxWidth: "18px",
                                                    }}
                                                />
                                            </span>
                                        </div>

                                    </div>
                                </span>
                            </label>
                        </div>

                    </div>
                </fieldset>
            </div>
        </div>
    );
}
